//
// Generated class IntegratorMappingEntity
//

/// <reference path="IntegratorMappingEntity_ManagedObject.ts" />

class IntegratorMappingEntity extends IntegratorMappingEntity_ManagedObject
{

}
